module.exports = __webpack_public_path__ + "media/src/assets/success_report_screen-82c937e42ad75278139f04a38c34c4ce.png";